import SeoHead from "@/components/SeoHead";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import AboutTeaser from "@/components/home/AboutTeaser";
import Services from "@/components/Services";
import AiSkillingTeaser from "@/components/home/AiSkillingTeaser";
import LatestNews from "@/components/LatestNews";
import HomeNewsletterCta from "@/components/home/HomeNewsletterCta";
import CallToAction from "@/components/CallToAction";
import Footer from "@/components/Footer";

const Index = () => {
  return (
    <>
      <SeoHead
        title={{
          en: "AI-labbet — Responsible AI strategy, training & advisory",
          sv: "AI-labbet — Strategi, utbildning & rådgivning inom ansvarsfull AI",
        }}
        description={{
          en: "AI-labbet inspires, transforms and advises organizations with responsible AI through thought leadership and executive advisory.",
          sv: "AI-labbet inspirerar, transformerar och rådgör med organisationer inom ansvarsfull AI genom thought leadership och executive advisory.",
        }}
        path="/"
      />

      <div className="min-h-screen bg-background flex flex-col">
        <Header />
        <main className="flex-1">
          <Hero />
          <Services />
          <AboutTeaser />
          <AiSkillingTeaser />
          <LatestNews />
          <HomeNewsletterCta />
          <CallToAction />
        </main>
        <Footer />
      </div>
    </>
  );
};
export default Index;


